import { ThemeUICSSObject, spacing } from '@apia/theme';

const iframeOverlay: ThemeUICSSObject = {
  background: 'palette.background.overlay',
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  p: spacing(0),
  zIndex: 'modal',

  svg: {
    position: 'fixed',
    left: '50vw',
    top: '50vh',
    transform: 'translate(-50%, -50%)',
  },

  iframe: {
    width: '100vw',
    height: '100vh',
    border: 'none',
  },
};

export default iframeOverlay;
